import { render, staticRenderFns } from "./AddPayCheque.vue?vue&type=template&id=176b6fc0&"
import script from "./AddPayCheque.vue?vue&type=script&lang=js&"
export * from "./AddPayCheque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports